"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualPaymentPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@ferry/journey-services");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var AnnualPaymentPanelWidget = /** @class */ (function (_super) {
    __extends(AnnualPaymentPanelWidget, _super);
    function AnnualPaymentPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderNewCardLink = function () {
            return (0, jsx_runtime_1.jsx)("a", { className: "btn-link-underline", id: "changeCard", href: _this.getNewPaymentCardPageHref(), "aria-label": "Use a different card to pay", onClick: _this.navigateToNewPaymentCardPage, children: "Use a different card" });
        };
        _this.renderCardsButtonsForSupportPortal = function () {
            if (_this.props.interaction.policyHolder.cardDetails && _this.props.interaction.agreeToReuseCardDetails) {
                return _this.renderCardDetailsButtons();
            }
            else {
                return _this.renderNewCardButton();
            }
        };
        _this.renderNewCardButton = function () {
            return (0, jsx_runtime_1.jsx)("button", { className: "btn btn-primary btn-make-payment m-auto", onClick: _this.navigateToNewPaymentCardPage, id: "pay-with-new-card", children: "Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(_this.props.interaction.factors.annualPremium)) });
        };
        _this.renderCardDetailsButtons = function () {
            var amountToPay = _this.getAmountToPay();
            var renderCancelChanges = _this.getSetting("renderCancelChangesButton", false);
            var cardsButtons = [];
            for (var _i = 0, _a = _this.props.interaction.policyHolder.cardDetails; _i < _a.length; _i++) {
                var cardDetails = _a[_i];
                cardsButtons.push((0, jsx_runtime_1.jsx)("div", { className: "pr-4", children: (0, jsx_runtime_1.jsx)("button", { className: "d-inline-block btn btn-primary ".concat(renderCancelChanges ? "btn-next" : "btn-make-payment m-auto"), onClick: _this.handleCardButtonClick, value: cardDetails.number, id: "card-" + cardDetails.number, "aria-label": "".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(amountToPay), " to pay"), children: "Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(amountToPay)) }, cardDetails.number) }));
            }
            return cardsButtons;
        };
        _this.renderCardsButtons = function () {
            if (_this.props.interaction.policyHolder.cardDetails) {
                return _this.renderCardDetailsButtons();
            }
        };
        _this.handleCardButtonClick = function (event) {
            _this.handleOnClick(event, event.currentTarget.value);
        };
        _this.getNewPaymentCardPageHref = function () {
            return _this.getSetting("newCardPaymentPage") || "#";
        };
        _this.navigateToNewPaymentCardPage = function (event) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            var newCardPaymentPage = _this.getSetting("newCardPaymentPage");
            if (newCardPaymentPage) {
                _this.props.engine.navigate(newCardPaymentPage, true);
            }
        };
        _this.renderCancelChangesButton = function () {
            return ((0, jsx_runtime_1.jsx)("button", { className: "btn btn-white btn-back", onClick: _this.handleCancelChangesClick, children: "Cancel changes" }));
        };
        _this.handleCancelChangesClick = function () {
            var renderCancelChanges = _this.getSetting("renderCancelChangesButton", false);
            if (renderCancelChanges) {
                _this.executeEvent("change");
            }
        };
        _this.renderCardInformation = function () {
            var card = _this.findMainPaymentCard();
            if (card) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex align-items-center mt-3 pb-8", children: (0, jsx_runtime_1.jsxs)("div", { className: "card-details-wrapper d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)("span", { className: "pr-2", children: _this.renderCardImage(card) }), "\u00A0", (0, jsx_runtime_1.jsx)("span", { children: _this.renderCardTypeName(card) }), "\u00A0", (0, jsx_runtime_1.jsxs)("span", { children: ["ending in ", (0, jsx_runtime_1.jsx)("b", { children: card.number.split("******")[1] })] })] }) }));
            }
            return null;
        };
        _this.renderCardImage = function (card) {
            if (card.type.includes("VISA")) {
                return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon-large", alt: "Visa icon", src: "/img/visa-icon.svg" });
            }
            if (card.type.includes("MASTERCARD")) {
                return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon-large", alt: "Mastercard icon", src: "/img/mastercard-icon.svg" });
            }
            return null;
        };
        _this.renderCardTypeName = function (card) {
            if (card.type.includes("VISA")) {
                return "Visa";
            }
            if (card.type.includes("MASTERCARD")) {
                return "Mastercard";
            }
            return "";
        };
        _this.getAmountToPay = function () {
            var payUpfrontInterest = _this.getSetting("payUpfrontInterest");
            var showRenewalAnnualPremium = _this.getSetting("showRenewalAnnualPremium");
            if (payUpfrontInterest === "true") {
                return _this.props.interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionPayment;
            }
            else if (showRenewalAnnualPremium === "true") {
                return _this.props.interaction.factors.annualPremium;
            }
            if (_this.props.interaction.factors.amountToPay && _this.props.interaction.uistate.payFullPrice) {
                return _this.props.interaction.factors.amountToPay;
            }
            else if (_this.props.interaction.factors.additionalPremium) {
                return _this.props.interaction.factors.additionalPremium;
            }
            else {
                return _this.props.interaction.paymentDetails.instalmentPlan.deposit;
            }
        };
        _this.setState({});
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    AnnualPaymentPanelWidget.prototype.render = function () {
        var additionalPremium = this.props.interaction.factors.amountToPay;
        var premium = this.props.interaction.factors.premium;
        var deposit = journey_services_1.productHelper.isWolfMotor(this.props.interaction) ? this.props.interaction.paymentDetails.instalmentPlan.deposit : 0;
        var showRenewalAnnualPremium = this.getSetting("showRenewalAnnualPremium");
        var shouldRenderPaymentContent = additionalPremium !== 0 || premium !== 0 || deposit !== 0 || showRenewalAnnualPremium != null;
        return shouldRenderPaymentContent ? this.renderPaymentContent() : null;
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentContent = function () {
        var payUpfrontInterest = this.getSetting("payUpfrontInterest");
        var payUpfrontPrice = (this.props.interaction.uistate &&
            (this.props.interaction.uistate.payFullPrice == undefined || !this.props.interaction.uistate.payFullPrice) &&
            journey_services_1.productHelper.isWolfMotor(this.props.interaction.product) &&
            this.props.interaction.factors.premiumType !== journey_services_1.PREMIUM_TYPE_ANNUAL) ||
            (this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL &&
                this.props.interaction.factors.debtAmount &&
                this.props.interaction.factors.debtAmount !== 0);
        var process = this.props.interaction.process;
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, commonFunctions_1.isCustomerPortalMta)(process) &&
                    this.renderPaymentOptionsForCustomerPortal(this.props.interaction, payUpfrontPrice, payUpfrontInterest === "true"), (0, commonFunctions_1.isSupportPortalMta)(process) && this.renderPaymentOptionsForSupportPortal(), (0, commonFunctions_1.isRenewal)(process) && this.renderPaymentForAnnualRenewal(this.props.interaction)] }));
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentOptionsForCustomerPortal = function (interaction, payUpfrontPrice, payUpfrontInterest) {
        // if setting is present, will render Cancel changes button in widget and change button classes to align them
        var renderCancelChangesButton = this.getSetting("renderCancelChangesButton", false);
        return interaction.agreeToReuseCardDetails ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), (0, jsx_runtime_1.jsx)("div", { className: "pb-2 pt-4 or-divider", children: " OR" }), this.renderNewCardLink, (0, jsx_runtime_1.jsxs)("div", { className: "panel-dashed-contents card-buttons d-flex justify-content-between", children: [renderCancelChangesButton && this.renderCancelChangesButton(), this.renderCardsButtons()] })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [renderCancelChangesButton && this.renderCancelChangesButton(), (0, jsx_runtime_1.jsxs)("button", { className: renderCancelChangesButton
                        ? "btn btn-primary btn-next d-flex justify-c-center margin-left-auto"
                        : "btn btn-primary btn-make-payment margin-left-auto", onClick: this.navigateToNewPaymentCardPage, id: "pay-with-new-card", children: [renderCancelChangesButton && this.renderCancelChangesButton(), "Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(this.getNewCardPaymentAmount(payUpfrontPrice, payUpfrontInterest)))] })] }));
    };
    AnnualPaymentPanelWidget.prototype.getNewCardPaymentAmount = function (payUpfrontPrice, payUpfrontInterest) {
        var result;
        if (payUpfrontInterest) {
            result = this.props.interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionPayment;
        }
        else if (payUpfrontPrice) {
            result = this.props.interaction.factors.upfrontPaymentAmount;
        }
        else {
            result = this.props.interaction.factors.amountToPay;
        }
        return result;
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentForAnnualRenewal = function (interaction) {
        return interaction.policyHolder.cardDetails
            && interaction.policyHolder.cardDetails.length > 0
            && this.props.interaction.agreeToReuseCardDetails ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), (0, jsx_runtime_1.jsx)("div", { className: "pb-2 pt-4 or-divider", children: " OR" }), this.renderNewCardLink(), (0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-buttons", children: this.renderCardsButtons() })] })) : (this.renderNewCardButton());
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentOptionsForSupportPortal = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), (0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-buttons", children: this.renderCardsButtonsForSupportPortal() })] }));
    };
    AnnualPaymentPanelWidget.prototype.handleOnClick = function (event, cardNumber) {
        var interaction = this.props.engine.getInteraction();
        var paymentDetails = interaction.paymentDetails;
        paymentDetails.cardNumber = cardNumber;
        this.props.engine.callInteractionSetState(__assign(__assign({}, this.props.engine.getInteraction()), { paymentDetails: paymentDetails }));
        this.executeEvent("click");
        event.preventDefault();
    };
    AnnualPaymentPanelWidget.prototype.findMainPaymentCard = function () {
        if (this.props.interaction.policyHolder.cardDetails.length !== 0) {
            return this.props.interaction.policyHolder.cardDetails[0];
        }
        return null;
    };
    AnnualPaymentPanelWidget = __decorate([
        components_1.authorize,
        (0, journey_model_1.settings)([
            { name: "payUpfrontInterest", type: journey_model_1.TypeDescriptions.String },
            { name: "renderCancelChangesButton", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualPaymentPanelWidget);
    return AnnualPaymentPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualPaymentPanelWidget = AnnualPaymentPanelWidget;
//# sourceMappingURL=AnnualPaymentPanelWidget.js.map